"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useTranslationNs_1 = require("../../hooks/useTranslationNs");
var Button_1 = __importDefault(require("../Button"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FilterDropdown = function (_a) {
    var children = _a.children, handleClick = _a.handleClick, label = _a.label, filterName = _a.filterName;
    var getTranslation = useTranslationNs_1.useTranslationNs('common', 'FILTER');
    return (react_1.default.createElement("div", { className: "filter-dropdown" },
        react_1.default.createElement("div", { onClick: handleClick, className: "mobile-header" },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.actions },
                react_1.default.createElement("span", { className: styles_module_scss_1.default.close }, getTranslation('CANCEL')),
                react_1.default.createElement(Button_1.default, { className: styles_module_scss_1.default.confirm }, getTranslation('DONE'))),
            react_1.default.createElement("span", { className: "m-title" }, getTranslation(label))),
        react_1.default.createElement("div", { className: "filter-content " + filterName + "-content" }, children),
        react_1.default.createElement("div", { className: "filter-footer" },
            react_1.default.createElement("a", { onClick: handleClick, className: "btn btn-green btn-bordered" }, getTranslation('CLOSE')))));
};
exports.default = FilterDropdown;
